jQuery(document).ready(function ($) {

    //Popup
    if ( Cookies.get('noti') !== 'closed') {
        $('.noa-popup').delay(4000).fadeIn();
    }

    $('.close-popup').on('click', function () {
        Cookies.set('noti','closed', { expires: 1 });
        $('.noa-popup').fadeOut();
    });

    $('.detalii').on('click', function(e){
        e.preventDefault();
        $('.noa-popup').fadeIn();

    })

    //Burger
    $('.burger').on('click', function () {
        $('body').removeClass('sticky').toggleClass('show-burger');
        $('.burger-helper').fadeToggle();
    });

    $('.menu-burger a').on('click', function () {
        $('body').removeClass('show-burger');
        $('.burger-helper').fadeToggle();
    });

    //Slider Home
    $('.slider-home').slick({
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 4000
    });

    //about-brief-gallery
    $('.about-brief-gallery').slick({
        arrows: false,
        dots: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 4000
    });

    $('.gallery-container').slick({
        arrows: true,
        dots: false,
        slidesToShow: 2,
        centerMode: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.project-gallery-wrapper').slick({
        arrows: true,
        dots: false,
        slidesToShow: 2,
        centerMode: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.apart-single-gallery').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000
    });

    $('.gallery-image').magnificPopup({
        type:'image',
        gallery: {
            enabled: true
        },
        preloader: true
    });

    $('.tabs-plans a').on('click', function(event){
        event.preventDefault();
        var tab = $(this).attr('href'); 
        $(this).parents('li').addClass('active').siblings().removeClass('active');
        $('#'+tab).addClass('active').siblings().removeClass('active')
        
    });

    $(window).scroll(function () {
      if( !$('body').hasClass('show-burger')){
        if ($(window).scrollTop() > 250  ) {
            $('body').addClass('sticky');
        }
        if ($(window).scrollTop() < 250) {
            $('body').removeClass('sticky');
        }
      }
    });



});
